import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ children }) => {
  const user = useSelector((state) => state.user.user);
  const token = localStorage.getItem("auth_token");

  if (!user || !token) {
    return <Navigate to="/signin" replace />;
  }

  return children;
};

export default ProtectedRoute; 